import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { LocalizationProvider } from '@mui/lab';
import AdapterLuxon from '@mui/lab/AdapterLuxon';
import {
  Box,
  CssBaseline,
  ThemeProvider as MuiThemeProvider,
} from '@mui/material';
import { SnackbarProvider } from 'notistack';
import { FC } from 'react';

import { ErrorOutline } from '@gmm/icons';

import { mobiusTheme } from './theme';

const AUTO_HIDE_AFTER = 4000;
const iconVariant = {
  error: (
    <Box
      component="span"
      sx={{
        alignItems: 'center',
        display: 'inline-flex',
        flexShrink: 0,
        height: 20,
        justifyContent: 'center',
        mr: 1,
        overflow: 'visible',
        width: 20,
      }}
    >
      <ErrorOutline sx={{ fontSize: 30 }} />
    </Box>
  ),
};

const cache = createCache({
  key: 'css',
  prepend: true,
  ...(process.env.NODE_ENV === 'development' && { stylisPlugins: [] }),
});

/**
 * @see https://github.com/mui-org/material-ui/issues/24894
 *
 * Turns off warnings that are specific to server-side rendering
 */
cache.compat = true;

export const ThemeProvider: FC = ({ children }) => (
  <LocalizationProvider dateAdapter={AdapterLuxon}>
    <CacheProvider value={cache}>
      <MuiThemeProvider theme={mobiusTheme}>
        <CssBaseline />
        <SnackbarProvider
          autoHideDuration={AUTO_HIDE_AFTER}
          iconVariant={iconVariant}
          maxSnack={3}
        >
          {children}
        </SnackbarProvider>
      </MuiThemeProvider>
    </CacheProvider>
  </LocalizationProvider>
);
